import React from "react";
import logoMd from "../../assets/images/ikizmet-md.png";
import logoDark from "../../assets/images/ikizmet-dark.png";
import { PRIVACY_URL, TOS_URL } from "./constants";
import { getCsrfToken } from "./csrf";

const AuthLayout = ({
  action,
  method = "post",
  formClassName,
  autoComplete,
  formInnerStyle,
  lightTheme,
  children,
  headerText,
  footer,
  showBackToSignIn,
  newUserSessionPath
}) => {
  const isGet = method === "get";

  return (
    <div className="signin text-center">
      <div className="outer">
        <div className="middle">
          <div className="inner">
            <div className="mbl">
              <img src={lightTheme ? logoDark : logoMd} alt="iKizmet" />
            </div>
            {headerText && <h4 style={{ paddingTop: "50px", color: "white" }}>{headerText}</h4>}
            <div className="form-inner" style={formInnerStyle}>
              <form
                className={formClassName}
                action={action}
                method={isGet ? "get" : "post"}
                autoComplete={autoComplete}
              >
                {!isGet && <input type="hidden" name="authenticity_token" value={getCsrfToken()} />}
                {!isGet && method !== "post" && (
                  <input type="hidden" name="_method" value={method} />
                )}
                {children}
              </form>
            </div>
            {footer || (
              <>
                {showBackToSignIn && (
                  <>
                    <a href={newUserSessionPath} className="privacy-policy no-decoration">
                      Back to Sign In
                    </a>
                    <br />
                  </>
                )}
                <a href={PRIVACY_URL} className="privacy-policy no-decoration">
                  Privacy Policy
                </a>
                <br />
                <a href={TOS_URL} className="privacy-policy no-decoration">
                  Terms of Service
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
